export function useSeoCraftPage({ error, data, status }, entryKey = 'entry') {
    const craftEntry = computed(() => data?.value?.[entryKey]);
    const craftSeoData = computed(() => craftEntry.value?.seomatic);
    const seoData = useSeoMatic(craftSeoData);

    useSchema(craftSeoData);
    useHead(seoData);

    watchEffect(() => {
        if (status.value === 'idle' || status.value === 'pending') {
            return;
        }

        if (!craftEntry?.value && unref(error)) {
            showError({
                statusCode: error.value?.statusCode || -1,
                statusMessage: error.value?.statusMessage || 'Internal server error',
                message: error.value?.toString()
            });
        } else if (!craftEntry?.value) {
            showError({ statusCode: 404, statusMessage: 'Page Not Found' });
        }
    });

    return {
        craftEntry
    };
}
